import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { VerticalNavigation } from '@salesforce/design-system-react';

import './ExperimentEditStep.scss';

class ExperimentEditStep extends Component {
  getI18nID(suffix) {
    return `components.experiment.experimentWizard.${suffix}`;
  }

  render() {
    const { formatMessage } = this.props.intl;
    const steps = [
      {
        id: 'progress',
        label: formatMessage({ id: this.getI18nID('progress') }),
        items: [
          {
            id: 'step0',
            label: formatMessage({ id: this.getI18nID('step0.progress') })
          },
          {
            id: 'step1',
            label: formatMessage({ id: this.getI18nID('step1.progress') })
          },
          {
            id: 'step2',
            label: formatMessage({ id: this.getI18nID('step2.progress') })
          },
          {
            id: 'step3',
            label: formatMessage({ id: this.getI18nID('step3.progress') })
          }
        ]
      }
    ];
    return (
      <div className="progress slds-col">
        <VerticalNavigation
          id="progress"
          categories={steps}
          selectedId={this.props.step}
          onSelect={(evt, data) =>
            this.props.canNav
              ? this.props.actions.updateModal('experimentWizard', {
                  currentStep: data.item.id
                })
              : null
          }
        />
      </div>
    );
  }
}

ExperimentEditStep.propTypes = {
  actions: PropTypes.shape({
    updateModal: PropTypes.func.isRequired
  }).isRequired,
  canNav: PropTypes.bool,
  step: PropTypes.string,
  intl: intlShape.isRequired
};

export default injectIntl(ExperimentEditStep);
